import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'components/UI/Button/Button';
import { searchFormSchema } from 'utils/form-validation-schema';
import { SearchContext } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';

import './SearchForm.scss';

export const SearchForm = () => {
  const { searchString, searchFormUpdateHandler } = useContext(SearchContext);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(searchFormSchema),
  });

  useEffect(() => {
    setValue('inputSearch', searchString);
  }, [searchString]);

  const searchErrorClass = errors.inputSearch ? 'input-error' : '';

  const onSearchSubmitHandler = (values) => {
    if (isValid) {
      searchFormUpdateHandler(values.inputSearch);
    }
  };

  return (
    <form
      className="search-form__form"
      onSubmit={handleSubmit(onSearchSubmitHandler)}
      data-testid="search-form"
    >
      <div className="row">
        <div className="col-sm-7 col-md-6 col-md-offset-2">
          <input
            name="inputSearch"
            placeholder="Search"
            className={`search-form__input ${searchErrorClass}`}
            {...register('inputSearch')}
            data-testid="input-search"
          />
          {errors.inputSearch && (
            <div className="search-form__errors">{errors?.inputSearch?.message}</div>
          )}
        </div>
        <div className="col-sm-5 col-md-2">
          <Button
            extendClass="btn-secondary search-form__submit-button"
            type="submit"
            disabled={!isValid}
          >
            Search
          </Button>
        </div>
      </div>
    </form>
  );
};

SearchForm.propTypes = {
  searchSubmitHandler: PropTypes.func,
};
